import React, { ReactNode, ReactElement } from 'react';

type PanelProps = {
    title?: string,
    subtitle?: string,
    children?: ReactNode,
    className?: string,
    buttons?: ReactElement,
    // key?: string
}

const Panel = (props:PanelProps) => {
    return (
        <div className={`panel ${props.className}`}>
           <div className="panel-header">
                <div>
                    {props.title && <div className="title">{props.title}</div>}
                    {props.subtitle && <div className="subtitle">{props.subtitle}</div>}
                </div>
                <div className="buttons">{props.buttons}</div>
            </div>
            <div className="panel-body">
                {props.children}
            </div>
        </div>
    )
}

export default Panel;